<template>
  <div>
    <zsmglMain />
  </div>
</template>

<script>
// 获取接口地址
import zsmglMain from '@/components/Zsmgl/zsmglMain.vue'

export default {
  name: 'Zsmgl',
  components: {
    zsmglMain
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
